import React, { useEffect } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { School } from './types/school';
import { PageContainer, StyledButton } from './styled';
import { fetchSchools } from '../../redux/slices/School';
import { AppDispatch } from '../../redux/store';

const SchoolListingTable = ({
  onEdit
}: {
  onEdit: (type: string, schoolId: string) => void;
}) => {
  const dispatch: AppDispatch = useDispatch();

  const { schools, schoolStatus } = useSelector(
    (state: RootState) => state.school
  );

  useEffect(() => {
    dispatch(fetchSchools());
  }, [dispatch]);

  if (schoolStatus === 'LOADING') {
    return (
      <PageContainer>
        <Typography variant='h6' align='center'>
          Loading...
        </Typography>
      </PageContainer>
    );
  }
  return (
    <TableContainer
      component={Paper}
      style={{
        borderRadius: '12px',
        maxHeight: 'calc(100vh - 250px)',
        overflow: 'auto'
      }}
    >
      <Table
        style={{ minWidth: 650 }}
        aria-label='school list table'
        stickyHeader
      >
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: 'bold' }}>Short Code</TableCell>
            <TableCell style={{ fontWeight: 'bold' }}>Display Code</TableCell>
            <TableCell align='right' style={{ fontWeight: 'bold' }}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schools?.map((school: School) => (
            <TableRow key={school.id}>
              <TableCell>{school.shortCode}</TableCell>
              <TableCell>{school.displayCode}</TableCell>
              <TableCell align='right'>
                <StyledButton
                  variant='contained'
                  size='small'
                  onClick={() => onEdit('edit', school.id)}
                >
                  Edit Details
                </StyledButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SchoolListingTable;
